import { render, staticRenderFns } from "./WorkflowDetail.vue?vue&type=template&id=7239d99e&scoped=true"
import script from "./WorkflowDetail.vue?vue&type=script&lang=js"
export * from "./WorkflowDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDetail.vue?vue&type=style&index=0&id=7239d99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7239d99e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSkeletonLoader,VTab,VTabItem,VTabs,VTabsItems})
